import React, { useEffect, useState } from "react";
import Content from "../../../components/Contents/Content";
import ReusableModal from "../../../components/Models/ReusableModal";
import { useLocation } from "react-router-dom";
import { BasketStockListdata, AddStockplaceorder, GetLivePricedataByID, GetLivePricedata, PortfolioStock, GetUserData } from "../../../Services/UserService/User";
import Loader from "../../../../Utils/Loader";
import io from 'socket.io-client';
import $ from "jquery";
import { soket_url } from '../../../../Utils/config';
import showCustomAlert from "../../../Extracomponents/CustomAlert/CustomAlert";


const BasketStockList = () => {


  // const SOCKET_SERVER_URL = "https://stockboxpnp.pnpuniverse.com:1001/"
  const SOCKET_SERVER_URL = soket_url



  const socket = io(SOCKET_SERVER_URL, { transports: ['websocket'] });


  useEffect(() => {
    getbasketpurchasedata();
    getuserdetail();
    getportfolio();
    getlivepricedata();
  }, []);



  const location = useLocation();
  const item = location?.state?.item;



  const token = localStorage.getItem("token");
  const userid = localStorage.getItem("id");


  const [showModal, setShowModal] = useState(false);
  const handleCloseModal = () => {
    setShowModal(false); setInputdata("");
    setIsConfirming(false)
  }

  const [activeTab, setActiveTab] = useState("baskets");


  const [isLoading, setIsLoading] = useState(false);
  const [isPlacingOrder, setIsPlacingOrder] = useState(false);

  const [isConfirming, setIsConfirming] = useState(false);
  const [purchasedata, setPurchasedata] = useState([]);
  const [inputdata, setInputdata] = useState({});
  const [userDetail, setUserDetail] = useState();
  const [portfolio, setPortfolio] = useState([]);
  const [livedata, setLivedata] = useState()
  const [checkQuantity, setCheckQuantity] = useState([])

  const [totalPL, setTotalPL] = useState(0);
  const [currentVal, setCurrentVal] = useState(0);

  const [totalPL1, setTotalPL1] = useState(0);
  const [currentVal1, setCurrentVal1] = useState(0);


  const totalInvestment = portfolio.reduce((acc, curr) => acc + curr.price * curr.totalQuantity, 0);
  const totalInvestment1 = purchasedata.reduce((acc, curr) => acc + curr.price * curr.quantity, 0);


  // Force re-render when checkQuantity updates
  useEffect(() => {
    if (isConfirming && checkQuantity && Object.keys(checkQuantity).length > 0) {
      const timeoutId = setTimeout(() => {
      }, 50);
      return () => clearTimeout(timeoutId);
    }
  }, [checkQuantity, isConfirming]);


  // calculation of Basket base

  const calculateValues1 = () => {
    let totalPL = 0;
    let currentVal = 0;
    let totalInvestment = 0;


    purchasedata.forEach((item) => {
      const livePriceElement = $(`#stock-price-${item.instrument_token}`);
      const livePrice = livePriceElement.length ? parseFloat(livePriceElement.text()) : null;

      if (livePrice && !isNaN(livePrice)) {
        const investment = item.price * item.quantity;
        totalInvestment += investment;
        currentVal += livePrice * item.quantity;
        totalPL += (livePrice - item.price) * item.quantity;
      }
    });


    const currentValueElement = $("#current-value");
    const totalPLElement = $("#total-pl");

    currentValueElement.text(`₹ ${currentVal.toFixed(2)}`);
    totalPLElement.text(`₹ ${totalPL.toFixed(2)}`);


    // Fixed: Check if currentVal is >= 0 instead of >= totalInvestment
    if (currentVal >= 0) {
      currentValueElement.css({ color: "green", transition: "color 0.5s ease-in-out" });
    } else {
      currentValueElement.css({ color: "red", transition: "color 0.5s ease-in-out" });
    }

    if (totalPL >= 0) {
      totalPLElement.css({ color: "green", transition: "color 0.5s ease-in-out" });
    } else {
      totalPLElement.css({ color: "red", transition: "color 0.5s ease-in-out" });
    }
  };


  const oldlivepriceCalculate = () => {
    let totalPL = 0;
    let currentVal = 0;
    let totalInvestment = 0;

    purchasedata.forEach((item) => {
      const liveMatch = livedata?.find(
        (live) => live?.token === item?.instrument_token
      );
      const livePrice = liveMatch?.lp;

      if (livePrice && !isNaN(livePrice)) {
        const investment = item.price * item.quantity;
        totalInvestment += investment;
        currentVal += livePrice * item.quantity;
        totalPL += (livePrice - item.price) * item.quantity;
      }
    });

    setTotalPL(totalPL.toFixed(2));
    setCurrentVal(currentVal.toFixed(2));


  };



  const oldlivepriceCalculate1 = () => {
    let totalPL = 0;
    let currentVal = 0;
    let totalInvestment = 0;

    portfolio.forEach((item) => {
      const liveMatch = livedata?.find(
        (live) => live?.token === item?.ordertoken
      );
      const livePrice = liveMatch?.lp;

      if (livePrice && !isNaN(livePrice)) {
        const investment = item.price * item.totalQuantity;
        totalInvestment += investment;
        currentVal += livePrice * item.totalQuantity;
        totalPL += (livePrice - item.price) * item.totalQuantity;
      }
    });

    setTotalPL1(totalPL.toFixed(2));
    setCurrentVal1(currentVal.toFixed(2));


  };





  const handleLiveData = (livedata) => {

    const stockData = purchasedata?.find((item) => item?.instrument_token === livedata?.tk);
    if (stockData) {
      const priceElement = $(`#stock-price-${livedata.tk}`);

      if (priceElement.length && livedata.lp && stockData.price) {
        priceElement.text(livedata.lp);

        if (livedata.lp > stockData.price) {
          priceElement.css({ color: "green", transition: "color 0.5s ease-in-out" });
        } else if (livedata.lp < stockData.price) {
          priceElement.css({ color: "red", transition: "color 0.5s ease-in-out" });
        }

        calculateValues1();
      }
    }
  };







  useEffect(() => {
    oldlivepriceCalculate()

    socket.on("Live_data", handleLiveData);
    return () => {
      socket.off("Live_data", handleLiveData);
    };

  }, [purchasedata, livedata]);

  useEffect(() => {
    oldlivepriceCalculate1()


    socket.on("Live_data", handleLiveData1);
    return () => {
      socket.off("Live_data", handleLiveData1);
    };
  }, [portfolio, livedata]);



  // calculation of  portfolio base



  const calculateValues = () => {
    let totalPL = 0;
    let currentVal = 0;
    let totalInvestment = 0;

    portfolio.forEach((item) => {
      const livePriceElement = $(`#stock-prices-${item.ordertoken}`);
      const livePrice = livePriceElement.length ? parseFloat(livePriceElement.text()) : null;

      if (livePrice && !isNaN(livePrice)) {
        const investment = item.price * item.totalQuantity;
        totalInvestment += investment;
        currentVal += livePrice * item.totalQuantity;
        totalPL += (livePrice - item.price) * item.totalQuantity;
      }
    });


    const currentValueElement = $("#current-value1");
    const totalPLElement = $("#total-pl1");

    currentValueElement.text(`₹ ${currentVal.toFixed(2)}`);
    totalPLElement.text(`₹ ${totalPL.toFixed(2)}`);


    // Fixed: Check if currentVal is >= 0 instead of >= totalInvestment
    if (currentVal >= 0) {
      currentValueElement.css({ color: "green", transition: "color 0.5s ease-in-out" });
    } else {
      currentValueElement.css({ color: "red", transition: "color 0.5s ease-in-out" });
    }

    if (totalPL >= 0) {
      totalPLElement.css({ color: "green", transition: "color 0.5s ease-in-out" });
    } else {
      totalPLElement.css({ color: "red", transition: "color 0.5s ease-in-out" });
    }
  };






  const handleLiveData1 = (livedata) => {
    const stockData = portfolio?.find((item) => item?.ordertoken === livedata?.tk);
    if (stockData) {
      const priceElement = $(`#stock-prices-${livedata.tk}`);

      if (priceElement.length && livedata.lp && stockData.price) {
        priceElement.text(livedata.lp);

        if (livedata.lp > stockData.price) {
          priceElement.css({ color: "green", transition: "color 0.5s ease-in-out" });
        } else if (livedata.lp < stockData.price) {
          priceElement.css({ color: "red", transition: "color 0.5s ease-in-out" });
        }
        calculateValues();
      }
    }

  };





  const getportfolio = async () => {
    try {
      const data = { id: item?._id, clientid: userid };
      const response = await PortfolioStock(data, token);
      if (response.status) {
        setPortfolio(response?.data)
      }
    } catch (error) {
      console.log("error", error);
    }
    setIsLoading(false);
  };




  const getbasketpurchasedata = async () => {
    try {
      const data = { id: item?._id };
      const response = await BasketStockListdata(data, token);
      if (response.status) {
        setPurchasedata(response?.data);
      }
    } catch (error) {
      console.log("error", error);
    }
    setIsLoading(false);
  };



  const getuserdetail = async () => {
    try {
      const response = await GetUserData(userid, token);
      if (response.status) {
        setUserDetail(response.data?.brokerid);
      }
    } catch (error) {
      console.log("error", error);
    }
  };


  const getlivepricedata = async () => {
    try {
      const response = await GetLivePricedataByID(item._id);

      if (response.status) {
        setLivedata(response.data)
      }
    } catch (error) {
      console.log("error", error);
    }
    setIsLoading(false);
  };





  const BUYstockdata = async (type) => {
    try {
      setIsPlacingOrder(true);

      const data = {
        basket_id: item?._id,
        clientid: userid,
        brokerid: userDetail,
        investmentamount: inputdata,
        type: type,
      };

      const response = await AddStockplaceorder(data, token);
      setIsPlacingOrder(false);

      if (response.status) {
        if (type === 0) {
          setIsConfirming(true);
          setCheckQuantity(response?.data[0]);
          showCustomAlert("Success", response.message || "Order Confirmed! Quantities updated.");
        } else if (type === 1) {
          showCustomAlert("Success", response.message || "Order Placed Successfully!")
            .then(() => {
              setShowModal(false);
              setInputdata("");
              setIsConfirming(false);
              setCheckQuantity([]);
            });
        }
      } else {
        setIsConfirming(false);
        showCustomAlert("error", response.message || "Order Failed");
      }
    } catch (error) {
      setIsPlacingOrder(false);
      setIsConfirming(false);
      showCustomAlert(
        "error",
        "An error occurred while placing the order. Please check your network or try again later."
      );
    }
  };



  return (
    <div className="basket-stock-list">
      <Content

        Page_title="Stock List"
        button_status={true}
        button_status1={portfolio.length > 0 ? true : false}
        button_title={"Rebalance History"}
        button_title1={"Rebalance"}
        route={`/user/rebalancehistory/${item._id}`}
        route1={`/user/rebalancestock/${item?._id}`}
        state1={{ data: item }}
        backbutton_status={false}
        backbutton_title="Back"
        backForword={true}
      >

        <ul className="nav nav-pills mb-3 justify-content-center border-bottom">
          <li className="nav-item">
            <button
              className={`nav-link ${activeTab === "baskets" ? "active btn-primary" : ""
                }`}
              onClick={() => setActiveTab("baskets")}
            >
              Baskets
            </button>
          </li>
          {portfolio.length > 0 ? <li className="nav-item">
            <button
              className={`nav-link ${activeTab === "portfolio" ? "active btn-primary" : ""
                }`}
              onClick={() => setActiveTab("portfolio")}
            >
              My Portfolio
            </button>
          </li> : ""}
        </ul>


        {
          activeTab === "baskets" && (
            isLoading ? <Loader /> :
              <>
                <div className="row">
                  <div className="col-md-4">
                    <div className="card mb-3 Anuj">
                      <div className="card-body p-2">
                        <ul className="list-group list-group-flush list shadow-none ">
                          <li className="list-group-item ">
                            Total Investment
                            <hr />
                            <h5
                              className={`mb-0 tab-color ${totalInvestment1 > 0 ? "positive" : "negative"}`}
                            >
                              ₹ {totalInvestment1?.toFixed(2)}
                            </h5>

                          </li>
                        </ul>
                      </div>
                    </div>
                  </div>
                  <div className="col-md-4">
                    <div className="card mb-3">
                      <div className="card-body p-2">
                        <ul className="list-group list-group-flush list shadow-none ">
                          <li className="list-group-item ">
                            Current Value
                            <hr />
                            <h5
                              id="current-value"
                              className={`mb-0 tab-color ${currentVal > 0 ? "positive" : "negative"}`}
                            >
                              ₹ {currentVal || "-"}
                            </h5>

                          </li>
                        </ul>
                      </div>
                    </div>
                  </div>
                  <div className="col-md-4">
                    <div className="card mb-3">
                      <div className="card-body p-2">
                        <ul className="list-group list-group-flush list shadow-none ">
                          <li className="list-group-item ">
                            Total P&L
                            <hr />
                            <h5
                              id="total-pl"
                              className={`mb-0 tab-color ${totalPL >= 0 ? "positive" : "negative"}`}
                            >
                              ₹ {totalPL || "-"}
                            </h5>

                          </li>
                        </ul>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="row">
                  <div className="table-responsive">
                    <table className="table signalstrategy-tablen">
                      <thead className="table-primary">
                        <tr>
                          <th>Symbol</th>
                          <th>Suggested Price</th>
                          <th>Quantity</th>
                          <th>Current Market Price</th>
                          <th>Stock Weightage</th>

                        </tr>
                      </thead>
                      <tbody>

                        {purchasedata?.map((item) => {
                          const liveMatch = livedata?.find(live => live?.token === item?.instrument_token);
                          const livePrice = liveMatch?.lp;

                          return (
                            <tr key={item?.name}>
                              <td>{item?.name}</td>
                              <td>{item?.price}</td>
                              <td>{checkQuantity.quantity || item?.quantity}</td>

                              {/* <td id={`stock-price-${item?.instrument_token}`}>
                                <span className="stock-price" style={{ color: item?.price < livePrice ? "green" : "red" }}>₹ {livePrice || "-"}</span>
                              </td> */}
                              <td id={`stock-price-${item?.instrument_token}`}>
                                <span
                                  className={`stock-price ${item?.price < livePrice ? "price-up" : "price-down"}`}
                                >
                                  ₹ {livePrice || "-"}
                                </span>
                              </td>


                              <td>{item?.weightage}%</td>
                            </tr>
                          );
                        })}

                      </tbody>
                    </table>
                  </div>
                  <button
                    className="btn btn-success w-auto ms-3"
                    onClick={() => setShowModal(true)}
                  >
                    Buy Now
                  </button>
                </div>
              </>

          )
        }


        {
          portfolio.length > 0 && activeTab === "portfolio" && (
            isLoading ? <Loader /> :
              <>
                <div className="row">
                  <div className="col-md-4">
                    <div className="card mb-3">
                      <div className="card-body p-2">
                        <ul className="list-group list-group-flush list shadow-none ">
                          <li className="list-group-item ">
                            Total Investment
                            <hr />
                            <h5 className={`mb-0 tab-color ${totalInvestment > 0 ? "positive" : "negative"}`}>₹ {totalInvestment.toFixed(2)}</h5>
                          </li>
                        </ul>
                      </div>
                    </div>
                  </div>
                  <div className="col-md-4">
                    <div className="card mb-3">
                      <div className="card-body p-2">
                        <ul className="list-group list-group-flush list shadow-none ">
                          <li className="list-group-item  ">
                            Current Value
                            <hr />
                            <h5 id="current-value1" className={`mb-0 tab-color ${currentVal1 > 0 ? "positive" : "negative"}`}>₹ {currentVal1 || "-"}</h5>
                          </li>
                        </ul>
                      </div>
                    </div>
                  </div>
                  <div className="col-md-4">
                    <div className="card mb-3">
                      <div className="card-body p-2">
                        <ul className="list-group list-group-flush list shadow-none ">
                          <li className="list-group-item ">
                            Total P&L
                            <hr />
                            <h5 id="total-pl1" className={`mb-0 tab-color ${totalPL1 > 0 ? "positive" : "negative"}`}>₹ {totalPL1 || "-"}</h5>
                          </li>
                        </ul>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="row">
                  <div className="table-responsive">
                    <table className="table ">
                      <thead className="table-primary">
                        <tr>
                          <th>Symbol</th>
                          <th>Suggested Price</th>
                          <th>Current Market Price</th>
                          <th>Quantity</th>
                        </tr>
                      </thead>
                      <tbody>
                        {portfolio?.map((item) => {
                          const liveMatch = livedata?.find(
                            (live) => live?.token === item?.ordertoken
                          );
                          const livePrice = liveMatch?.lp;

                          return (
                            <tr key={item?.name}>
                              <td>{item?.tradesymbol}</td>
                              <td>{item?.price}</td>
                              {/* <td id={`stock-prices-${item?.ordertoken}`}>
                                <span className="stock-prices" style={{ color: item?.price < livePrice ? "green" : "red" }}>{livePrice || "-"}</span>
                              </td> */}
                              <td id={`stock-price-${item?.instrument_token}`}>
                                <span
                                  className={`stock-price ${item?.price < livePrice ? "price-up" : "price-down"}`}
                                >
                                  ₹ {livePrice || "-"}
                                </span>
                              </td>
                              <td>{item?.totalQuantity}</td>
                            </tr>
                          );
                        })}


                      </tbody>
                    </table>
                  </div>
                  <button
                    className="btn btn-success w-auto ms-3"
                    onClick={() => setShowModal(true)}
                  >
                    Buy Now
                  </button>
                </div>
              </>
          )
        }


        <ReusableModal
          show={showModal}
          onClose={handleCloseModal}
          title={<>Investment Amount</>}
          body={
            <div>
              <div className="d-flex align-items-center gap-2">
                <input
                  type="number"
                  className="form-control "
                  placeholder="Enter Investment Amount"
                  value={inputdata}
                  onChange={(e) => setInputdata(e.target.value)}
                  style={{ maxWidth: '350px' }}
                />

                <button
                  className="btn btn-primary "
                  onClick={() => BUYstockdata(0)}
                  disabled={isPlacingOrder || isConfirming}
                >
                  Confirm
                </button>
              </div>
              <p className="fs-14 mb-0 mt-1">
                Minimum Investment Amount: <strong>₹ {item?.mininvamount}</strong>
              </p>


              {isConfirming && (
                <table className="strategy-table table border mt-4">
                  <tbody>
                    <tr>
                      <th>Stock Name</th>
                      <th>CMP</th>
                      <th>Quantity</th>
                    </tr>
                    {activeTab === "baskets"
                      ? purchasedata?.map((item) => {
                        const liveMatch = livedata?.find(live => live?.token === item?.instrument_token);
                        const livePrice = liveMatch?.lp;

                        let displayQuantity = item?.quantity;
                        if (isConfirming && checkQuantity) {
                          if (Array.isArray(checkQuantity)) {
                            const found = checkQuantity.find(q => q.instrument_token === item.instrument_token);
                            displayQuantity = found ? found.quantity : item?.quantity;
                          } else {
                            displayQuantity = checkQuantity.quantity || item?.quantity;
                          }
                        }

                        return (
                          <tr key={item?.name}>
                            <td>{item?.name}</td>
                            <td id={`stock-price-${item?.instrument_token}`}>
                              <span className="stock-price">{livePrice || "-"}</span>
                            </td>
                            <td>
                              <strong style={{ color: isConfirming ? 'green' : 'inherit' }}>
                                {displayQuantity}
                              </strong>
                            </td>
                          </tr>
                        );
                      })
                      : portfolio?.map((item) => {
                        const liveMatch = livedata?.find(live => live?.token === item?.ordertoken);
                        const livePrice = liveMatch?.lp;

                        let displayQuantity = item?.totalQuantity;
                        if (isConfirming && checkQuantity) {
                          if (Array.isArray(checkQuantity)) {
                            const found = checkQuantity.find(q => q.ordertoken === item.ordertoken);
                            displayQuantity = found ? (found.totalQuantity || found.quantity) : item?.totalQuantity;
                          } else {
                            displayQuantity = checkQuantity.totalQuantity || checkQuantity.quantity || item?.totalQuantity;
                          }
                        }

                        return (
                          <tr key={item?.name}>
                            <td>{item?.tradesymbol}</td>
                            <td id={`stock-prices-${item?.ordertoken}`}>
                              <span className="stock-prices">{livePrice || "-"}</span>
                            </td>
                            <td>
                              <strong style={{ color: isConfirming ? 'green' : 'inherit' }}>
                                {displayQuantity}
                              </strong>
                            </td>
                          </tr>
                        );
                      })
                    }
                  </tbody>
                </table>
              )}
            </div>
          }
          footer={
            <>
              <button
                className="btn btn-primary"
                onClick={() => BUYstockdata(1)}
                disabled={!isConfirming}
              >
                Place Order
              </button>

              <button className="btn btn-light" onClick={handleCloseModal}>
                Cancel
              </button>
            </>
          }
        />

        {/* <ReusableModal
          show={showModal}
          onClose={handleCloseModal}
          title={<>Investment Amount</>}
          body={
            <div>
              <div className="d-flex align-items-center gap-2">
                <input
                  type="number"
                  className="form-control "
                  placeholder="Enter Investment Amount"
                  value={inputdata}
                  onChange={(e) => setInputdata(e.target.value)}
                  style={{ maxWidth: '350px' }}
                />

                <button
                  className="btn btn-primary "
                  onClick={() => BUYstockdata(0)}
                  disabled={isPlacingOrder ?? isConfirming}
                >
                  Confirm
                </button>
              </div>
              <p className="fs-14 mb-0 mt-1">
                Minimum Investment Amount: <strong>₹ {item?.mininvamount}</strong>
              </p>
              <table className="strategy-table table border mt-4">
                <tbody>
                  <tr>
                    <th>Stock Name</th>
                    <th>CMP</th>
                    <th>Quantity</th>
                  </tr>
                  {activeTab === "baskets"
                    ? purchasedata?.map((item) => {
                      const liveMatch = livedata?.find(live => live?.token === item?.instrument_token);
                      const livePrice = liveMatch?.lp;


                      let displayQuantity = item?.quantity;
                      if (isConfirming && checkQuantity) {
                        if (Array.isArray(checkQuantity)) {
                          const found = checkQuantity.find(q => q.instrument_token === item.instrument_token);
                          displayQuantity = found ? found.quantity : item?.quantity;
                        } else {
                          displayQuantity = checkQuantity.quantity || item?.quantity;
                        }
                      }

                      return (
                        <tr key={item?.name}>
                          <td>{item?.name}</td>
                          <td id={`stock-price-${item?.instrument_token}`}>
                            <span className="stock-price">{livePrice || "-"}</span>
                          </td>
                          <td>
                            <strong style={{ color: isConfirming ? 'green' : 'inherit' }}>
                              {displayQuantity}
                            </strong>
                          </td>
                        </tr>
                      );
                    })
                    : portfolio?.map((item) => {
                      const liveMatch = livedata?.find(live => live?.token === item?.ordertoken);
                      const livePrice = liveMatch?.lp;


                      let displayQuantity = item?.totalQuantity;
                      if (isConfirming && checkQuantity) {
                        if (Array.isArray(checkQuantity)) {
                          const found = checkQuantity.find(q => q.ordertoken === item.ordertoken);
                          displayQuantity = found ? (found.totalQuantity || found.quantity) : item?.totalQuantity;
                        } else {
                          displayQuantity = checkQuantity.totalQuantity || checkQuantity.quantity || item?.totalQuantity;
                        }
                      }

                      return (
                        <tr key={item?.name}>
                          <td>{item?.tradesymbol}</td>
                          <td id={`stock-prices-${item?.ordertoken}`}>
                            <span className="stock-prices">{livePrice || "-"}</span>
                          </td>
                          <td>
                            <strong style={{ color: isConfirming ? 'green' : 'inherit' }}>
                              {displayQuantity}
                            </strong>
                          </td>
                        </tr>
                      );
                    })
                  }

                </tbody>
              </table>
            </div>
          }
          footer={
            <>
              <button
                className="btn btn-primary"
                onClick={() => BUYstockdata(1)}
                disabled={!isConfirming}
              >
                Place Order
              </button>

              <button className="btn btn-light" onClick={handleCloseModal}>
                Cancel
              </button>
            </>
          }
        /> */}
      </Content >
    </div >
  );
};

export default BasketStockList;